import React, { useState, useEffect } from 'react';
import { View, TouchableOpacity, StyleSheet, Dimensions, Platform } from 'react-native';
import Svg, { Path } from 'react-native-svg';
import PopUp from '../popUp';
import PopUpInfo from '../popUpInfo';
import PopUpWaiting from '../popUpWaiting';
import theme from '../../constants/theme.style.js';
import CustomText from '../customText/CustomText';

const { width } = Dimensions.get('window');

const styles = StyleSheet.create({
  headerContainer: {
    height: 100,
    ...Platform.select({
      web: {
        height: width > 800 ? 100 : 70,
      },
    }),
    position: 'relative',
  },
  headerIconContainer: {
    position: 'absolute',
    zIndex: 5,
    width: 60,
    height: 55,
    bottom: 10,
    left: theme.CONTAINER_MARGIN,
  },
  headerIconContainerRight: {
    position: 'absolute',
    bottom: 10,
    right: theme.CONTAINER_MARGIN,
    width: 60,
    height: 55,
  },
  headerIcon: {
    margin: 20,
  },
  recipient: {
    position: 'absolute',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    height: 80,
    right: 0,
    left: 0,
    bottom: 0,
    marginBottom: 15,
  },
  recipientFirstname: {
    color: theme.WHITE_COLOR,
    fontSize: theme.FONT_SIZE_HEADLINE,
    fontWeight: theme.FONT_WEIGHT_BOLD,
    textAlign: 'center',
  },
  recipientNickname: {
    color: theme.GREY_LIGHT_COLOR,
    fontSize: theme.FONT_SIZE_REGULAR,
    textAlign: 'center',
  },
});

const NewMessageHeader = ({
  title,
  navigation,
  nextScreen,
  previousScreen,
  onDraftSend,
  onOutboxRefetch,
  draft,
  currentUser,
  allowNext = true,
  web = false,
}) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [modalDescription, setModalDescription] = useState('');
  const [modalButtonText, setModalButtonText] = useState('');
  const [infoVisible, setInfoVisible] = useState(false);
  const [infoDescription, setInfoDescription] = useState('Please select a friend.');
  const [infoButtonText] = useState('Ok.');
  const [waitingVisible, setWaitingVisible] = useState(false);
  const [currentScreen, setCurrentScreen] = useState('NewMessage');

  useEffect(() => {
    if (navigation) {
      setCurrentScreen(navigation.state.routeName);
    } else {
      setCurrentScreen(nextScreen);
    }
  }, [currentScreen]);

  async function callbackModalAccept() {
    setModalVisible(false);
    setWaitingVisible(true);
    const response = onDraftSend(currentUser.user.id);
    response.then((value) => {
      if (value) {
        setTimeout(() => {
          onOutboxRefetch(currentUser.user.id);
          const redirectTo = web ? 'NewMessage' : 'NewMessageFriendsSelection';
          navigation.navigate(redirectTo, {
            title,
          });
          navigation.navigate('Inbox', {
            title,
          });
          setWaitingVisible(false);
        }, 1000);
      } else {
        setWaitingVisible(false);
      }
    });
  }

  function callbackInfoAccept() {
    setInfoVisible(false);
  }

  function callbackModalNotNow() {
    setModalVisible(false);
  }

  return (
    <View style={styles.headerContainer}>
      {previousScreen !== '' && (
        <TouchableOpacity
          style={styles.headerIconContainer}
          onPress={() => {
            navigation.navigate(previousScreen, {
              title,
            });
          }}
          testID="backButton"
        >
          <Svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={styles.headerIcon}
          >
            <Path
              d="M0.939341 10.9393C0.353554 11.5251 0.353554 12.4749 0.939341 13.0607L10.4853 22.6066C11.0711 23.1924 12.0208 23.1924 12.6066 22.6066C13.1924 22.0208 13.1924 21.0711 12.6066 20.4853L4.12132 12L12.6066 3.51472C13.1924 2.92893 13.1924 1.97919 12.6066 1.3934C12.0208 0.807611 11.0711 0.807611 10.4853 1.3934L0.939341 10.9393ZM24 10.5L2 10.5V13.5L24 13.5V10.5Z"
              fill="white"
            />
          </Svg>
        </TouchableOpacity>
      )}
      {currentScreen === 'NewMessage' && draft.friend !== '' && (
        <View style={styles.recipient}>
          <CustomText style={styles.recipientFirstname} testID="recipientFirstname">
            {draft.friend.firstname}
          </CustomText>
          <CustomText style={styles.recipientNickname} testID="recipientNickname">
            @{draft.friend.nickname}
          </CustomText>
        </View>
      )}
      {allowNext && (
        <TouchableOpacity
          style={styles.headerIconContainerRight}
          onPress={() => {
            if (
              currentScreen === 'NewMessageTimeSelection' &&
              draft.friend.firstname === undefined
            ) {
              setInfoDescription('Please select a friend.');
              setInfoVisible(true);
            } else if (
              currentScreen === 'NewMessageTimeSelection' &&
              (draft.text === undefined || draft.text === '')
            ) {
              setInfoDescription('Please write a messsage.');
              setInfoVisible(true);
            } else if (currentScreen === 'NewMessageTimeSelection') {
              setModalVisible(true);
              setModalDescription(
                `Send turtlet to ${draft.friend.firstname} @${
                  draft.friend.nickname
                } with arrival on ${draft.date.toString().substring(4, 21)}?`,
              );
              setModalButtonText('Send');
            } else {
              navigation.navigate(nextScreen, {
                title,
              });
            }
          }}
          testID="nextButton"
          data-test="nextButton"
        >
          <Svg
            style={styles.headerIcon}
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <Path
              d="M0 0L1.75037 12.2526L2.74 12.5L1.75037 12.7474L0 25L25 12.5L0 0ZM4.04522 10.1828L3.23096 4.48296L19.2652 12.5001L3.23096 20.5172L4.04522 14.8173L13.3141 12.5001L4.04522 10.1828Z"
              fill="white"
            />
          </Svg>
        </TouchableOpacity>
      )}

      {modalVisible && (
        <PopUp
          description={modalDescription}
          button1={modalButtonText}
          callback1={callbackModalAccept}
          button2="Not now"
          callback2={callbackModalNotNow}
          visability={modalVisible}
        />
      )}
      {infoVisible && (
        <PopUpInfo
          description={infoDescription}
          button={infoButtonText}
          callback={callbackInfoAccept}
          button2="Not now"
          visability={infoVisible}
        />
      )}
      {waitingVisible && <PopUpWaiting visability={waitingVisible} />}
    </View>
  );
};

export default NewMessageHeader;
